<template>
  <div>
    <el-drawer :visible.sync="visible" direction="rtl" size="45%">
      <template slot="title">
        <div style="width: 100%; display: flex; align-items: center">
          <el-button
            type="primary"
            @click="visible = false"
            style="margin-right: 10px"
            >关闭</el-button
          >
          <div>移交任务详情---{{ title }}</div>
        </div>
      </template>
      <div class="drawer-content" v-loading="loading">
        <el-descriptions
          title=""
          :column="1"
          border
          labelClassName="descriptionslabel"
        >
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px">供应商</div>
            </template>
            <el-tag
              v-for="value in row.SupplierName?.split(',') || []"
              :key="value"
              style="margin-right: 10px"
              >{{ value }}</el-tag
            >
          </el-descriptions-item>
        </el-descriptions>

        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <span style="font-size: 18px">移交设备清单</span>
            </template>
            <el-table :data="deviecData">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="device_no"
                label="设备编号"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="device_name"
                label="设备名称"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备规格"
                prop="specification"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>

              <el-table-column
                label="设备数量"
                prop="Num"
                align="right"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="供应商名称"
                prop="SupplierName"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span style="font-size: 18px">移交通用配件清单</span>
            </template>
            <el-table :data="AccessoryData">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="AccessoryCode"
                label="配件编号"
                align="center"
                sortable
                show-overflow-tooltip
              />
              <el-table-column
                prop="Name"
                label="配件名称"
                align="center"
                sortable
                show-overflow-tooltip
              />

              <!-- <el-table-column
          prop="MaterialType"
          label="配件类型"
          align="center"
          sortable
          show-overflow-tooltip
        /> -->

              <el-table-column
                prop="Spec"
                label="配件规格"
                align="center"
                sortable
                show-overflow-tooltip
              />

              <!-- <el-table-column
          prop="Unit"
          label="计量单位"
          align="center"
          sortable
          show-overflow-tooltip
        /> -->
              <el-table-column
                prop="Nums"
                label="配件数量"
                align="right"
                sortable
                show-overflow-tooltip
              />
              <el-table-column
                label="供应商名称"
                prop="SupplierName"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <span style="font-size: 18px">移交项目资料清单</span>
            </template>
            <el-table :data="FilesData">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="TypeName"
                label="文件类型"
                align="center"
                sortable
                show-overflow-tooltip
              />
              <el-table-column
                prop="NewFileName"
                label="文件名称"
                align="center"
                sortable
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <a
                    :href="scope.row.Url"
                    target="_blank"
                    style="color: #409eff"
                  >
                    {{ scope.row.NewFileName }}
                  </a>
                </template>
              </el-table-column>

              <el-table-column
                prop="SupplierName"
                label="供应商名称"
                align="center"
                sortable
                show-overflow-tooltip
              />
            </el-table>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">
              <span style="font-size: 18px">移交资质资料清单</span>
            </template>
            <el-table :data="TypeFiles">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="TypeName"
                label="文件类型"
                align="center"
                sortable
                show-overflow-tooltip
              />
              <el-table-column
                prop="NewFileName"
                label="文件名称"
                align="center"
                sortable
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <a
                    :href="scope.row.Url"
                    target="_blank"
                    style="color: #409eff"
                  >
                    {{ scope.row.NewFileName }}
                  </a>
                </template>
              </el-table-column>

              <el-table-column
                prop="SupplierName"
                label="供应商名称"
                align="center"
                sortable
                show-overflow-tooltip
              />
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      title: '',
      Id: '',
      row: {},
      //设备移交数据
      deviecData: [],
      //配件移交数据
      AccessoryData: [],
      //项目资料移交数据
      FilesData: [],
      //资质移交数据
      TypeFiles: [],
      activeNames: [],
    }
  },
  props: {},
  components: {},
  methods: {
    open(row) {
      this.row = row
      this.Id = row.Id
      this.title = row.Name || ''
      this.visible = true
      this.deviecData = []
      this.AccessoryData = []
      this.FilesData = []
      this.TypeFiles = []
      this.activeNames = ['1', '2', '3', '4']
      this.getInfo()
    },
    getInfo() {
      this.loading = true
      this.$http
        .post(`/Base_ProjectWork/project_taskhandover/GetTheTaskHandoverData`, {
          id: this.Id,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.deviecData = res.Data.device_Taskhandoverdetails || []
            this.AccessoryData = res.Data.accessory_Taskhandoverdetails || []
            this.FilesData =
              res.Data.projectSupplierFiles_Taskhandoverdetails || []
            this.TypeFiles =
              res.Data.projectSupplierTypeFiles_Taskhandoverdetails || []
          } else {
            this.$notify.error(res.Msg)
          }
          console.log(res)
        })
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.drawer-content {
  width: 100%;
  height: 100%;
  padding: 0px 20px;
  overflow-y: auto;
}
.transfer-container {
  display: flex;
  height: calc(100% - 40px);
  padding: 20px 0px;
  gap: 20px;
}

.transfer-panel {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
  display: flex;
  // justify-content: space-between;
  align-items: center;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    margin-right: 20px;
  }

  .selected-count {
    color: #909399;
    font-size: 12px;
  }
}
::v-deep .descriptionslabel {
  width: 100px;
  font-size: 16px;
  font-weight: bold;
}
</style>
